import { render, staticRenderFns } from "./AcronymsRegister.vue?vue&type=template&id=142aafc8"
import script from "./AcronymsRegister.vue?vue&type=script&lang=js"
export * from "./AcronymsRegister.vue?vue&type=script&lang=js"
import style0 from "./AcronymsRegister.vue?vue&type=style&index=0&id=142aafc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports